import moment from 'moment-timezone';

export const validateZipcodeCoverage = (handybook_host, zipcode, service_machine_name) => {
    return $.get({
        url: `${handybook_host}/api/services/v1/zipcode_coverage`,
        data: {
            zipcode: zipcode,
            service_machine_name: service_machine_name,
        },
    })
    .catch(error => {
        return Promise.reject({ source: 'zipcode', error });
    });
};

export const validateTimeCoverage = (handybook_host, zipcode, service_machine_name, partner_name, service_duration_minutes, startsAt) => {
    return $.post({
        url: `${handybook_host}/api/services/v1/time_coverage`,
        data: $.param({
            quote_request: timeValidationParams(zipcode, service_machine_name, partner_name, service_duration_minutes, startsAt),
        }),
    })
    .catch(error => {
        return Promise.reject({ source: 'time', error });
    });
};

const timeValidationParams = (zipcode, service_machine_name, partner_name, service_duration_minutes, startsAt) => {
    return {
        user_originating_platform: "handy",
        service_name: service_machine_name,
        zipcode: zipcode,
        frequency: "one_time",
        starts_at: `${startsAt}`,
        commitment: "no_commitment",
        duration: service_duration_minutes,
        requires_responses: false,
        partner_machine_name: partner_name,
    };
};
